import axios from "axios";
import { store } from "@/store/store";

export default () => {
  return axios.create({
    baseURL:
      process.env.NODE_ENV === "production"
        ? `${process.env.VUE_APP_TRANSFER_URL}/${process.env.VUE_APP_TRANSFER_PORT_REVERSE_PROXY}`
        : `${process.env.VUE_APP_TRANSFER_URL}:${process.env.VUE_APP_TRANSFER_PORT}`,
    headers: {
      Authorization: `Bearer ${store.state.token}`,
    },
  });
};
